import React from "react";

import "../styles.scss";
import "../scripts";

import {
  FCPrimaryCollectionBlock,
  getDefaultProps,
  KameleonElement,
  primaryCollectionBlock,
} from "@kameleon-core/lib";
import ThreeCol from "@kameleon-section/content-collection-three-col-small-media-v1";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentCollectionType, layoutOptions } from "./types/prop-types";

const ThreeColComponent = ThreeCol.component as FCPrimaryCollectionBlock<any>;
export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  ThreeColComponent.blockConfig,
  ({ ...props }: ContentCollectionType) => (
    <ThreeColComponent
      className="primary-collection-content-collection-two-col-medium-media-v1"
      {...props}
    />
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
